(function (Drupal, once) {
  Drupal.behaviors.artworkAudio = {
    attach(context) {
      const player = context.querySelector('.artwork-audio--player')
      once('artworkAudio', '.artwork-audio a', context).forEach(element => {
        element.addEventListener('click', (event) => {
          event.preventDefault()
          player.classList.toggle('hidden');
        })
      })
    }
  }
})(Drupal, once);
